import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloseQuote1: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="close-quote-1, blockquote">
      <path
        d="M6.48986 5C4.0283 5 2 6.95019 2 9.39583C2 11.8415 4.0283 13.7917 6.48986 13.7917C7.42886 13.7917 8.30482 13.5079 9.02918 13.0211C8.8255 13.56 8.56249 14.031 8.25362 14.4567C7.37729 15.6645 6.08904 16.5744 4.47836 17.6211L3.8495 18.0298L4.6669 19.2876L5.29576 18.8789C6.89069 17.8423 8.40734 16.799 9.46771 15.3376C10.5513 13.8441 11.117 11.9794 10.9797 9.37492C10.9682 6.93909 8.94441 5 6.48986 5Z"
        fill="currentColor"
      />
      <path
        d="M17.4899 5C15.0283 5 13 6.95019 13 9.39583C13 11.8415 15.0283 13.7917 17.4899 13.7917C18.4289 13.7917 19.3048 13.5079 20.0292 13.0211C19.8255 13.56 19.5625 14.031 19.2536 14.4567C18.3773 15.6645 17.089 16.5744 15.4784 17.6211L14.8495 18.0298L15.6669 19.2876L16.2958 18.8789C17.8907 17.8423 19.4073 16.799 20.4677 15.3376C21.5513 13.8441 22.117 11.9794 21.9797 9.37492C21.9682 6.93909 19.9444 5 17.4899 5Z"
        fill="currentColor"
      />
    </CentralIconBase>
  );
};

export default IconCloseQuote1;
